/**
 * 本代码主要还是适配早期的天地图浙江底图，增加了很多的判断，比如图层id号的判断，比如底图类型的判断
 * 但是根据最新的国家天地图代码，没有了根据当前范围请求图层编号的操作，所以只需要加载底图就可以了，不需要进行判断
 * 代码还没有进行优化，等待后面的人进行优化吧，先实现功能。
 */
import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import {defaults as interactionDefaluts } from 'ol/interaction';
import {get as getProj } from 'ol/proj';
import LayerGroup from 'ol/layer/Group';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import TileLayer from 'ol/layer/Tile';
import {getTopLeft} from 'ol/extent';

import _without from 'lodash/without';
import _debounce from 'lodash/debounce';

import {defaults as controlDefaluts} from 'ol/control';
import ZoomSlider from 'ol/control/ZoomSlider';
import XYZ from 'ol/source/XYZ';


export default class TMap extends Map {
    // 覆盖 species 到父级的 Map 构造函数上,这样返回的TMap就是一个Map类型了。
    static get [Symbol.species]() { return Map; }
    
    projection=getProj("EPSG:4326");
    maxLevel=20;
    // 声明构造函数
    constructor(id,{center=[120.158, 30.267],level=16,maptype="emg",option={}}={
        center:[120.158, 30.267],level:16,maptype:"emg"
    }){
        let zoomSlider=option.zoomSlider;
        let controls=null;
        if(zoomSlider){
            controls=new controlDefaluts().extend([    // 往地图增加控件
                new ZoomSlider(),            // 滑块缩放控件
            ])
        }else{
            controls=new controlDefaluts();
        }
        super({
            logo:false,
            target:id,
            interactions: interactionDefaluts({
                doubleClickZoom:false
            }),
            controls: controls,
            view:new View({
                center: center,
                projection: getProj("EPSG:4326"),
                zoom: level,
                maxZoom: 18,
                minZoom: 2
            }),
            layers: []
        });
        this.layerArray=[];//地图图层数组
        this.events={};//地图事件列表
        this.maptype = maptype;
        this.level=level;
        this.center=center;
        this.id=id;

        // 加载地图
        this.addCartoDbLayer();
    }
    // 屏幕分辨率
    resolutions=[1.40625, 0.703125, 0.3515625, 0.17578125, 0.087890625, 0.0439453125, 0.02197265625, 0.010986328125,
        0.0054931640625, 0.00274658203125, 0.001373291015625, 0.0006866455078125, 0.00034332275390625, 0.000171661376953125,
        0.0000858306884765625, 0.00004291534423828125, 0.000021457672119140625, 0.000010728836059570312, 0.000005364418029785156,
        0.000002682209014892578, 0.000001341104507446289];
    
    //获取地图类型
    getMapType(){
        return this.maptype;
    }

    //根据图层名称获取图层
    getLayerByName(name) {
        var mapColle = this.getLayers().getArray();
        for (var i = 0; i < mapColle.length; i++) {
            if (mapColle[i].get('name') === name) {
                return mapColle[i];
            }
        }
        return null;
    }
    //根据编号获取图层分辨率
    getResolution(zoom) {
        return this.resolutions[zoom];
    }

    // 添加CartoDb图层
    addCartoDbLayer(){
        let layer=new TileLayer({
            source: new XYZ({
                url:'http://{a-d}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
            }),
        });
        // 显示Logo
        layer.on("postrender",function (event) {
            var context=event.context;
            context.save();
            context.rotate(-45*Math.PI/180);

            // 设置字体
            context.font = "30px bold 黑体";
            // 设置颜色
            context.fillStyle = "#aaaaaa87";
            // 设置水平对齐方式
            context.textAlign = "center";
            var width=context.canvas.width;
            var height=context.canvas.height;
            context.translate(-width,-height);
            // 设置垂直对齐方式
            context.textBaseline = "middle";
            var text="谱恒高科技有限责任公司";
            var drawCount=25;
            // x方向循环绘制
            for(var i=0;i<drawCount+2;i++){
                var x=500*i;
                for(var j=0;j<=drawCount+5;j++){
                    var y=300*j;
                    // 绘制文字（参数：要写的字，x坐标，y坐标）
                    context.fillText(text, x, y);
                }
            }
            context.restore();
        });
        this.addLayer(layer);
    }
}